import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from "react-router";
import { ApplicationState } from "../../store";
import { TeamRole } from '../../store/Models/UserContext';
import { ToxnotComponentProperties } from "../core/BaseApplicationComponents/ToxnotComponent";
import { ToxnotSignInRequiredComponent } from "../core/BaseApplicationComponents/ToxnotSignInRequiredComponent";
import Layout from "../Layout";

type AIAssistantAbstractionProps =
    RouteComponentProps &
    ToxnotComponentProperties;

export abstract class AIAssistantAbstraction extends ToxnotSignInRequiredComponent<AIAssistantAbstractionProps> {
    protected getDisallowedRoles(): TeamRole[] {
        return []; // no roles disallowed
    }

    protected abstract renderAIAssistantContent(): JSX.Element;

    protected renderConcreteComponent(): JSX.Element | null {
        const userContext = this.getUserContext();

        if (userContext == null) {
            return <div></div>;
        }

        if (!userContext.userCapabilities.aiAssistantEnabled) {
            return (
                <Layout>
                    <div className="tn-section text-center">
                        <p>{this.localizeString("You don't have access the view Portfolio Assistant Page")}</p>
                    </div>
                </Layout>
            )
        }

        return (
            <Layout>
                <div className="tn-section">
                    {this.renderAIAssistantContent()}
                </div>
            </Layout>
        );
    }

    protected getUserObject() {
        const userContext = this.getUserContext();
        //return {
        //    userName: userContext?.emailAddress
        //};
        return userContext ? { userName: userContext.emailAddress, email: userContext.emailAddress } : { userName: '', email: '' };
    }
}

export function withCommonAIAssistant<P extends AIAssistantAbstractionProps>(
    WrappedComponent: React.ComponentType<P>
) {
    return connect(
        (state: ApplicationState) => ({ appServices: state.appServices })
    )(WrappedComponent as any);
}